import React from 'react'
import styles from './generic-error.styles'
import injectSheet from 'react-jss'
import Container from '../components/container/container'
import Title from '../components/title/title'
import Description from '../components/description/description'
import duck from '../../../../images/duck-confused.gif'
import Button from 'pobble-components/dist/button'

const GenericError = ({ classes, errorRef }) => (
  <Container>
    <img className={classes.img} src={duck} alt="Duck fixer" />
    <Title>
      We're sorry.
      <br />
      That has us confused too.
    </Title>
    <Description>
      <p>
        We have logged the error and are looking into it. If this continues to
        happen please contact{' '}
        <a href="mailto:hello@pobble.com">hello@pobble.com</a>
      </p>
      {errorRef && <p className={classes.ref}>Ref: {errorRef}</p>}
    </Description>
    <Button tall href="/">
      Take me back home
    </Button>
  </Container>
)

export default injectSheet(styles)(GenericError)
